import { Option } from "@finvia/money-ui";
import { TFunction } from "i18next";

export const salutations = (t: TFunction): Option[] => [
  { value: "MRS", text: t(`options.salutations.MRS`) },
  { value: "MR", text: t(`options.salutations.MR`) },
  { value: "NONE", text: t(`options.salutations.NONE`) },
];
